import { render, staticRenderFns } from "./VsTab.vue?vue&type=template&id=53d6566e&lang=html"
import script from "./VsTab.vue?vue&type=script&lang=js"
export * from "./VsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports